import { render, staticRenderFns } from "./WarningsDetail.vue?vue&type=template&id=5221b219&"
import script from "./WarningsDetail.vue?vue&type=script&lang=ts&"
export * from "./WarningsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports